 //Generic toaster implementation
import { SHOW_TOASTER } from '../types'

export const showToaster = (option) => async (dispatch) => {
  dispatch({
    type: SHOW_TOASTER,
    payload: option
  })
}